import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=dfb365d4&scoped=true"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb365d4",
  null
  
)

export default component.exports